import React from "react";
import Widget from "../Widget";
import Icon from "../../../ui/icons/Icon";
import classes from "./WidgetCarouselCard.module.css";

const WidgetCarouselCard = ({ color, title, titleColor = "#000", image, imageAlt, icon, iconColor, link, onClick, className, imageFill = false }) => (
    <Widget
        color={color}
        mainLink={onClick ? undefined : link}
        onClick={onClick}
        contentScrollable={false}
        className={`${classes.WidgetCarouselCard} ${imageFill ? classes.ImageFill : ""} ${className || ""}`}
    >
        <div className={classes.Content} style={{ color: titleColor }}>
            <div className={classes.ImageArea}>
                {image && <img src={image} alt={imageAlt || title} className={classes.Image} />}
                {!image && icon && <Icon name={icon} size="40px" color={iconColor || titleColor} />}
            </div>
            {!imageFill && title && <p className={classes.Title}>{title}</p>}
        </div>
    </Widget>
);

export default WidgetCarouselCard;
